var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "is_hover",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8002 14C24.8002 13.5581 24.442 13.2 24.0002 13.2C23.5584 13.2 23.2002 13.5581 23.2002 14V23.2H14.0002C13.5584 23.2 13.2002 23.5581 13.2002 24C13.2002 24.4418 13.5584 24.8 14.0002 24.8H23.2002V34C23.2002 34.4418 23.5584 34.8 24.0002 34.8C24.442 34.8 24.8002 34.4418 24.8002 34V24.8H34.0002C34.442 24.8 34.8002 24.4418 34.8002 24C34.8002 23.5581 34.442 23.2 34.0002 23.2H24.8002V14Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.c8eba9783de4b2cc857fd771a972687e.svg";
export { ForwardRef as ReactComponent };